import React from "react";
import { StyledTag, StyledSupportCard, StyledSnippet, StyledArticleTitle, StyledLink } from "../style/support.style";

const SupCard = ({ card }) => {
  return (
    <StyledSupportCard id={card.id}>
      <StyledTag>{card.tag}</StyledTag>
      <StyledArticleTitle>{card.header}</StyledArticleTitle>
      <StyledSnippet>{card.snippet}</StyledSnippet>
      {card.learnMoreHref ? <StyledLink href={card.learnMoreHref}>Learn More</StyledLink> : null}
    </StyledSupportCard>
  );
};
export default SupCard;